import 'whatwg-fetch';
import Fingerprint2 from 'fingerprintjs2';
import CryptoJS from 'crypto-js';
import MobileDetect from 'mobile-detect';
import {getChannel} from '@/utils/channel';

const defaultChannel =  getChannel()


export interface paramsType {
  eventId: string;
  channel?: string | undefined;
  cid?: number | undefined;
  trackId?: string | undefined;
  failReason?: string | undefined
}

class LogEscalation {

  static logRequest: any;

  /**
   * 日志上报请求
   * @param params
   * @returns {Promise<void>}
   */
  async logRequest(params: paramsType) {
    const {eventId, channel = defaultChannel, cid = '', trackId = '', failReason = ''} = params;
    const userId = window.localStorage.getItem('userId') || ''
    console.log(userId);
    const clientId = await this.getClientId()
    const appkey = {key: '5WtKrLZP', value: 'NgAbCJJGfUlQ6653'}
    const deviceInfo: any =  this.deviceInfo()
    const paramsString = this.encrypt(appkey.value, {
      eventId, //事件ID
      androidId: clientId, // 浏览器指纹唯一标示
      imei: '',
      mac: '',
      osVer: deviceInfo.version(deviceInfo.userAgent()),
      appVer: '1.0.0',
      isRoot: 0,
        model: deviceInfo.userAgent(),
      network: this.getNetworkType(),
      pkgName: window.location.host,
      userId,
      isEmulator: 0,
      source: 6,
      channel,
      failReason,
      cid,
      trackId,
      brand: deviceInfo.phone()
    })
    await this.report(appkey.key, paramsString)
  }


  async stitching(params) {
    const f = '\t'
    const {eventId, appVer, channel = 'haima004', source = 6, failReason, trackId} = params;
    const userId = window.localStorage.getItem('userId');
    const androidId = await this.getClientId();
    let data = {
      eventId, appVer, channel, source, failReason, trackId, androidId, userId
    }
  }

  /**
   * 获取浏览器指纹
   * @returns {Promise}
   */
  async getClientId() {
    const clientId = window.localStorage.getItem('clientId')
    if (clientId) return clientId
    return new Promise(function (resolve) {
      Fingerprint2.get((result) => {
        let values = result.map(component => component.value)
        window.localStorage.setItem('clientId', Fingerprint2.x64hash128(values.join(''), 31))
        resolve(Fingerprint2.x64hash128(values.join(''), 31))
      })
    });
  }

  /**
   * 加密
   * @param data
   * @param key
   * @returns {string}
   */
  encrypt(key, data) {
    console.log(data);
    key = CryptoJS.enc.Latin1.parse(key);
    let encrypted = CryptoJS.AES.encrypt(
      JSON.stringify(data),
      key,
      {
        mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7
      });
    return encrypted.toString();
  }

  async report(appkey, paramsString) {
    fetch('/log/event/report/app', {
      method: 'POST',
      headers: {appkey},
      body: paramsString
    }).then()
  }

  deviceInfo() {
    return  new MobileDetect(window.navigator.userAgent)
  }

  /**
   * 获取网络连接状态
   * @returns {any}
   */
  getNetworkType() {
    let ua = navigator.userAgent;
    let networkStrUa: any = ua.match(/NetType\/\w+/)
    let networkStr = networkStrUa ? networkStrUa[0] : 'NetType/other';
    networkStr = networkStr.toLowerCase().replace('nettype/', '');
    let networkType;
    switch(networkStr) {
      case 'wifi':
        networkType = 'wifi';
        break;
      case '4g':
        networkType = '4g';
        break;
      case '3g':
        networkType = '3g';
        break;
      case '3gnet':
        networkType = '3g';
        break;
      case '2g':
        networkType = '2g';
        break;
      default:
        networkType = 'other';
    }
    return networkType
  }

}

export default  new LogEscalation()



